<mat-action-list>
  @for (consumer of consumers; track consumer) {
    <button
      [attr.data-testid]="consumer.name + '_consumer'"
      mat-list-item
        [ngClass]="{ 'selected': consumer === (selectedConsumer$ | async) ||
        consumer.tag === (selectedConsumer$ | async)?.tag || false }"
      (click)="onConsumerSelected(consumer)"
      >
      {{ consumer.name }}
    </button>
  }
</mat-action-list>
